/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { ToastContainer } from "react-toastify";
import styled from "styled-components";
import type {} from "styled-components/cssprop";
import { Loader } from "@nordcloud/gnui";
import { Navbar } from "~/components";
import Footer from "~/components/Footer/Footer";
import { LOCAL_STORAGE } from "~/constants/localStorage";
import GlobalSwitch from "./routing/Routes/GlobalSwitch";

function App() {
  const [isLoading, setIsLoading] = React.useState(true);

  const LoaderWrap = styled.div`
    padding: 1rem;
  `;

  React.useEffect(() => {
    const token = localStorage.getItem(LOCAL_STORAGE.token);
    token && setIsLoading(false);
  }, []);

  return isLoading ? (
    <LoaderWrap>
      <Loader inContent />
    </LoaderWrap>
  ) : (
    <>
      <div css={{ flex: "1 0 auto" }}>
        <ToastContainer css={{ width: "400px", whiteSpace: "pre-wrap" }} />
        <Navbar />
        <GlobalSwitch />
      </div>
      <Footer />
    </>
  );
}

export default App;
